import { render, staticRenderFns } from "./InterventionRecomendation.vue?vue&type=template&id=2f24e5d9"
import script from "./InterventionRecomendation.vue?vue&type=script&lang=js"
export * from "./InterventionRecomendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f24e5d9')) {
      api.createRecord('2f24e5d9', component.options)
    } else {
      api.reload('2f24e5d9', component.options)
    }
    module.hot.accept("./InterventionRecomendation.vue?vue&type=template&id=2f24e5d9", function () {
      api.rerender('2f24e5d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/appointment/components/InterventionRecomendation.vue"
export default component.exports